import { combineReducers } from 'redux';
import * as actions from './actions';

export interface IExpertState {
  loading: boolean;
  loadingForm: boolean;
  error: object | null;
  successfullyRegistered: string;
  expert: object;
  experts: {
    profile: {
      firstName: string;
      photoUrl: string;
    };
    therapy: {
      price: {
        online?: number;
        offline?: number;
      }
    };
    expertId: string;
  }[];
};

const initExpertState = {
  expertId: '',
  profile: {
    firstName: '',
    videoUrl: '',
    photoUrl: '',
    about: '',
    shortDescription: '',
  },
  education: {
    basic: [],
    extra: [],
  },
  experience: {
    years: null,
    diplomas: [],
    infoText: null,
  },
  therapy: {
    price: {
      online: null,
      offline: null
    },
    themeBadges: [],
    languages: [],
    address: '',
  },
};

export default combineReducers<IExpertState>({
  loading(state: boolean = false, action) {
    switch (action.type) {
      case actions.GET_ALL_EXPERTS_REQUEST:
      case actions.GET_EXPERTS_BY_IDS_REQUEST:
        return true;
      case actions.GET_ALL_EXPERTS_SUCCESS:
      case actions.GET_EXPERTS_BY_IDS_SUCCESS:
      case actions.GET_ALL_EXPERTS_FAILURE:
      case actions.GET_EXPERTS_BY_IDS_FAILURE:
        return false;
      default:
        return state;
    }
  },
  loadingForm(state: boolean = false, action) {
    switch (action.type) {
      case actions.CONTACT_EXPERT_REQUEST:
      case actions.QUESTION_EXPERT_REQUEST:
        return true;
      case actions.CONTACT_EXPERT_SUCCESS:
      case actions.CONTACT_EXPERT_FAILURE:
      case actions.QUESTION_EXPERT_SUCCESS:
      case actions.QUESTION_EXPERT_FAILURE:
        return false;
      default:
        return state;
    }
  },
  error(state = null, action) {
    switch (action.type) {
      case actions.CONTACT_EXPERT_FAILURE:
      case actions.QUESTION_EXPERT_FAILURE:
      case actions.GET_ALL_EXPERTS_FAILURE:
        return action.error || null;
      default:
        return state;
    }
  },
  successfullyRegistered(state: string = "", action) {
    switch (action.type) {
      case actions.CONTACT_EXPERT_SUCCESS:
      case actions.QUESTION_EXPERT_SUCCESS:
        return action.data;
      case actions.RESET_SUCCESS_STATE:
        return "";
      default:
        return state;
    }
  },
  experts(state: object[] = [], action) {
    switch (action.type) {
      case actions.GET_ALL_EXPERTS_SUCCESS:
      case actions.GET_EXPERTS_BY_IDS_SUCCESS:
        return action.data;
      case actions.GET_ALL_EXPERTS_FAILURE:
      case actions.GET_EXPERTS_BY_IDS_FAILURE:
        return [];
      default:
        return state;
    }
  },
  expert(state: object = initExpertState, action) {
    switch (action.type) {
      case actions.GET_EXPERT_SUCCESS:
        return action.data;
      case actions.GET_EXPERT_FAILURE:
        return {};
      default:
        return state;
    }
  },
});
